export default {
  news: [],
  popularNews: []
}